// dependencies
import React from "react";

// styles
import styles from "./css/Tag.module.css";

export default function Tag({ text, fontSize, backgroundColor, color}) {

    return (
        // background
        <div className={styles.tag} style={
            {
                backgroundColor: backgroundColor, 
                color: color,
                fontSize: fontSize
            }
        }>
            {text}
        </div>
    );
}
